import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';

import { environment } from 'src/environments/environment';
interface IPayloadBestValue {
  LoggedInUser: string;
  CourseID: number | string;
}

export interface ICheckCourseExistsRequest {
  LoggedInUser: string;
  SessionLanguageTypeCode: string;
  FromCourseID: number;
  ToExamAgencyID: number;
  ToCourseMasterID: number;
  ToExamYear: number;
  ToExamMonth: string | null;
}
@Injectable({ providedIn: 'root' })
export class CourseManagementHttpService {
  private BASE_URL = environment.apiBaseUrl;
  constructor(private readonly httpClient: HttpClient) {}

  getDropdownListByCode<T>(code: string): Observable<IGetCodes[]> {
    return this.httpClient
      .get<{ resultList: IGetCodes[] }>(`${this.BASE_URL}api/GetCodes/${code}`)
      .pipe(map((response) => response.resultList));
  }

  public checkGetCoursePlanBestValueCheck<T>(
    data: IPayloadBestValue
  ): Observable<T> {
    return this.httpClient.post<T>(
      `${this.BASE_URL}/api/GetCoursePlanBestValueCheck`,
      data
    );
  }

  getCourses<T>(
    loggedInUserId: string,
    courseMasterID: string,
    courseId: string | null,
    screenName: string,
    studentId: string | null
  ): Observable<T> {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetCourse?LoggedInUserId=${loggedInUserId}&CourseMasterID=${courseMasterID}&CourseID=${courseId}&ScreenName=${screenName}&StudentID=${studentId}`
    );
  }

getCoursePlan<T>(
  loggedInUserId: string,
  courseId: number,
  coursePlanId:  number |null,
  screenName: string,
  studentId: string | null,
  StudyMaterialID: number | string | null
) {
  const body = {
    LoggedInUser: loggedInUserId,
    CourseID: +courseId,
    CoursePlanID: coursePlanId,
    ScreenName: screenName,
    StudentID: studentId,
    StudyMaterialID: StudyMaterialID
  };

  return this.httpClient.post<T>(
    `${this.BASE_URL}api/CoursePlanAndFeatures`,
    body
  );
}


  createOrUpdateCourse<T>(formData: FormData) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateCourse`,
      formData
    );
  }

  createOrUpdateCoursePlan<T>(formData: FormData) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateCoursePlan`,
      formData
    );
  }

  cloneCourse<T>(formData: FormData) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/CoursesClone`,
      formData
    );
  }

  performCourseCloning<T>(payload: ICheckCourseExistsRequest) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/PerformCourseCloning`,
      payload
    );
  }

  checkCourseExists<T>(payload: ICheckCourseExistsRequest) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/CheckCourseExists`,
      payload
    );
  }

  getCourseMaster<T>(
    loggedInUserId: string,
    examAgencyId: number,
    courseMasterID: string = ''
  ) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetCourseMaster?LoggedInUserId=${loggedInUserId}&ExamAgencyId=${examAgencyId}&CourseMasterID=${courseMasterID}`
    );
  }
}
